import { useSelector } from 'react-redux';
import { PortalConfigurationRolesSettingsKeys } from 'types';
import { AppPages, PortalConfigurationType, VendorContactRole } from '@trnsact/trnsact-shared-types';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { RoutingAccessPortalConfiguration } from '../routingAccess/types';

export function usePortalConfigurationChecks() {
  const role = useSelector<any, string>(state => state.userProfile.vendorContactRole);
  const portalConfigurationData = useSelector(portalConfigurationsSelectors.configData);

  const checkPortalConfigEntryForCurrentUserRole = (
    type: PortalConfigurationType,
    key: PortalConfigurationRolesSettingsKeys
  ) => {
    return checkPortalConfigEntryForRole(type, key, role as VendorContactRole);
  };

  const checkPortalConfigEntryForRole = (
    type: PortalConfigurationType,
    key: PortalConfigurationRolesSettingsKeys,
    targetRole: VendorContactRole
  ) => {
    const portalConfiguration = portalConfigurationData?.[type];
    const rolesSettings = portalConfiguration?.jsonDefinition?.config?.rolesSettings?.[key];

    return !!rolesSettings?.includes(targetRole);
  };

  const hasPortalConfiguration = (type: PortalConfigurationType): boolean => {
    return !!portalConfigurationData?.[type];
  };

  const checkAftermarketPartnerAllowSendProposals = (): boolean => {
    const portalConfiguration = portalConfigurationData?.[PortalConfigurationType.Aftermarket];
    return !!portalConfiguration?.jsonDefinition?.config?.partnerAllowSendProposals;
  };

  const checkRoutingAccessForCurrentUserRole = (appPage: AppPages): boolean => {
    const routingAccessConfig: RoutingAccessPortalConfiguration | undefined =
      portalConfigurationData?.[PortalConfigurationType.RoutingAccess]?.jsonDefinition?.config;

    if (!routingAccessConfig) return false;

    const hiddenRoles = routingAccessConfig.accessByPage[appPage]?.rolesSettings?.hidden ?? [];

    return hiddenRoles.includes(role as VendorContactRole);
  };

  return {
    checkPortalConfigEntryForCurrentUserRole,
    checkPortalConfigEntryForRole,
    hasPortalConfiguration,
    checkAftermarketPartnerAllowSendProposals,
    checkRoutingAccessForCurrentUserRole,
  };
}
